import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import DashboardScreen from "../Screens/DashboardScreen/DashboardScreen";
import CalculatorScreen from "../Screens/CalculatorScreen/CalculatorScreen";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../reducers/userReducer";
import ErrorScreen from "../Screens/ErrorScreen/ErrorScreen";
import { Auth } from "aws-amplify";
import LoadingScreen from "../Screens/LoadingScreen/LoadingScreen";
import { setNormalData } from "../../reducers/normalDataReducer";
import { setRecruitingData } from "../../reducers/recruitingDataReducer";
import { setGoals } from "../../reducers/goalsReducer";
import {
  getDataApi,
  getGoalsApi,
  getUserDataApi,
  recordLoginApi,
  setIncomeGoalsApi,
} from "../../Api";
import Header from "../Header/Header";
import { closeHelpPopup, closeIncomeSettingsPopup } from "../../reducers/popupsReducer";
import cloneDeep from "lodash/cloneDeep";
import IncomeGoalsPopup from "../IncomeGoalsPopup/IncomeGoalsPopup";
import HelpPopup from "../HelpPopup/HelpPopup";
import AdminScreen from "../Screens/AdminScreen/AdminScreen";
import { Modal } from "@mui/material";

function Main() {
  const dispatch = useDispatch();

  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  const goals = useSelector((state) => state.goals.value);
  const normalData = useSelector((state) => state.normalData.value);
  const recruitingData = useSelector((state) => state.recruitingData.value);
  const userData = useSelector((state) => state.user.value);
  const incomeSettingsPopup = useSelector((state) => state.popups.incomeSettingsPopup);
  const helpPopup = useSelector((state) => state.popups.helpPopup);

  async function signOut() {
    try {
      setLoading(true);
      dispatch(setUser(null));
      dispatch(setNormalData([]));
      dispatch(setRecruitingData([]));
      dispatch(setGoals(null));
      await Auth.signOut();
    } catch (error) {
      console.log("error signing out: ", error);
    }
  }

  const getUserDataCallback = (rtndata) => {
    console.log("rtndata", rtndata);
    if (rtndata["status"] === "ERROR") {
      setError(true);
      setLoading(false);
    } else {
      const cleanedUserData = {};

      const rtnUserData = rtndata["data"];

      cleanedUserData.companyId = rtnUserData.companyId.S;
      cleanedUserData.role = rtnUserData.role.S;
      cleanedUserData.lastName = rtnUserData.lastName.S;
      cleanedUserData.firstName = rtnUserData.firstName.S;
      cleanedUserData.email = rtnUserData.email.S;
      cleanedUserData.id = rtnUserData.id.S;
      cleanedUserData.incomeGoals = {};
      // if ('incomeGoals' in rtnUserData)
      // {
      try {
        cleanedUserData.incomeGoals.insuranceGoal = parseInt(
          rtnUserData.incomeGoals.M.insuranceGoal.N
        );
      } catch (e) {
        cleanedUserData.incomeGoals.insuranceGoal = 0;
      }
      try {
        cleanedUserData.incomeGoals.investmentGoal = parseInt(
          rtnUserData.incomeGoals.M.investmentGoal.N
        );
      } catch (e) {
        cleanedUserData.incomeGoals.investmentGoal = 0;
      }
      try {
        cleanedUserData.incomeGoals.averageCaseSize = parseInt(
          rtnUserData.incomeGoals.M.averageCaseSize.N
        );
      } catch (e) {
        cleanedUserData.incomeGoals.averageCaseSize = 0;
      }

      dispatch(setUser(cleanedUserData));
    }
  };

  const getDataApiCallback = (rtndata) => {
    const dashTypes = [
      { type: "normal", setter: (data) => dispatch(setNormalData(data)) },
      {
        type: "recruiting",
        setter: (data) => dispatch(setRecruitingData(data)),
      },
    ];

    if (rtndata == null) {
      console.log("error");
    } else {
      dashTypes.forEach((type) => {
        const rawData = rtndata[type.type];

        let cleanedData = [];

        rawData.forEach((record) => {
          const newRecord = {};

          newRecord.firstName = record["First name"];
          newRecord.email = record["email"].toLowerCase();
          newRecord.contacts = record["How many new contacts did you have this week?"];
          newRecord.helpNote = record["What can we help you with this week?"];
          newRecord.lastName = record["Last name"];
          newRecord.intros = record["How many introductions did you receive this week?"];
          newRecord.opens = record["How many case opens did you have this week?"];
          newRecord.cois = record["How many COI meetings did you have this week?"];
          newRecord.submissionTime = record["Submitted At"];
          newRecord.total = record["sum"];
          newRecord.perfectWeek = 0; //set later

          newRecord.displayName = newRecord.firstName + " " + newRecord.lastName;
          try {
            newRecord.displayName = newRecord.firstName.substring(0, 1) + ". " + newRecord.lastName;
          } catch (error) {
            console.log("invalid user input:" + record);
          }

          cleanedData.push(newRecord);
        });

        cleanedData = addPerfectWeekField(cleanedData);

        type.setter(cleanedData);
      });
    }
  };

  const getGoalsApiCallback = (rtndata) => {
    if (rtndata == null) {
      console.log("error");
    } else {
      // let total = 0

      const cleanedGoals = {};

      for (const [key, value] of Object.entries(rtndata)) {
        // total = total + value
        cleanedGoals[key] = value;
      }

      // cleanedGoals.total = total

      dispatch(setGoals(cleanedGoals));
    }
  };

  const addPerfectWeekField = (data) => {
    const newData = [];

    data.forEach((record) => {
      let perfectWeek = true;

      for (const goal in goals) {
        if (record[goal] < goals[goal]) {
          perfectWeek = false;
          break;
        }
      }

      record.perfectWeek = perfectWeek ? 1 : 0;
      newData.push(record);
    });

    return newData;
  };

  const recordLogin = () => {
    recordLoginApi(Date.now());
  };

  const loadData = () => {
    getUserDataApi(getUserDataCallback).then(() => {
      getDataApi(getDataApiCallback);
      getGoalsApi(getGoalsApiCallback);
      recordLogin();
    });
  };

  const handleIncomeGoalsSave = (insuranceGoal, investmentGoal, averageCaseSize, callback) => {
    const mainCallback = (rtndata) => {
      if (rtndata.status == "ERROR") {
        callback("ERROR");
        // setError(true)
      } else {
        const newUserData = cloneDeep(userData);
        newUserData.incomeGoals.insuranceGoal = insuranceGoal;
        newUserData.incomeGoals.investmentGoal = investmentGoal;
        newUserData.incomeGoals.averageCaseSize = averageCaseSize;

        dispatch(setUser(newUserData));

        callback("SUCCESS");
      }
    };

    const newGoals = {
      insuranceGoal: insuranceGoal,
      investmentGoal: investmentGoal,
      averageCaseSize: averageCaseSize,
    };

    setIncomeGoalsApi(newGoals, mainCallback);
  };

  useEffect(async () => {
    loadData();
  }, []);

  if (
    loading &&
    userData !== null &&
    recruitingData.length !== 0 &&
    normalData.length !== 0 &&
    goals !== null
  ) {
    setLoading(false);
  }
  // else if (userData !== null && recruitingData !== null && normalData !== null && goals !== null)

  if (loading) {
    return <LoadingScreen />;
  } else if (error) {
    return <ErrorScreen signOut={signOut} />;
  }

  return (
    <BrowserRouter>
      <Header signOut={signOut} />
      <Routes>
        <Route index path="/" element={<DashboardScreen />} />
        <Route path="calculator" element={<CalculatorScreen />} />
        <Route path="admin" element={<AdminScreen />} />
      </Routes>

      <IncomeGoalsPopup
        open={incomeSettingsPopup}
        handleClose={() => dispatch(closeIncomeSettingsPopup())}
        handleSave={handleIncomeGoalsSave}
        defaultInsuranceGoal={userData.incomeGoals.insuranceGoal}
        defaultInvestmentGoal={userData.incomeGoals.investmentGoal}
        defaultAverageCaseSize={userData.incomeGoals.averageCaseSize}
      />
      <HelpPopup
        open={helpPopup}
        handleClose={() => dispatch(closeHelpPopup())}
        handleSave={handleIncomeGoalsSave}
        defaultInsuranceGoal={userData.incomeGoals.insuranceGoal}
        defaultInvestmentGoal={userData.incomeGoals.investmentGoal}
        defaultAverageCaseSize={userData.incomeGoals.averageCaseSize}
      />
    </BrowserRouter>
  );
}

export default Main;
